import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

import Layout, { LayoutContent, LayoutFooter } from '~/App/components/Layout'
import { LayoutLoadingContent } from '~/App/components/LoadingLayout'
import useFinishFlow from '~/App/Flow/hooks/useFinishFlow'
import useProductVariant from '~/App/ProductVariants/hooks/useProductVariant'
import StoreLayoutHeader from '~/App/Store/components/StoreLayoutHeader'
import useCloseStore from '~/App/Store/hooks/useCloseStore'
import { Button } from '~/DesignSystem/components/button'

import { useProductId } from '../..'

const AddProductSuccessPage: React.FC = () => {
  const id = useProductId()
  const productVariantState = useProductVariant(id, {
    avoidRefetch: true,
  })
  const { mutate: finishFlow, isPending: finishingFlow } = useFinishFlow()
  const close = useCloseStore()

  useEffect(() => {
    if (productVariantState.loaded) {
      finishFlow()
    }
  }, [productVariantState.loaded])

  if (productVariantState.error) {
    throw productVariantState.error
  }

  return (
    <Layout>
      <StoreLayoutHeader />
      {productVariantState.loading && <LayoutLoadingContent />}
      {productVariantState.loaded && (
        <>
          <LayoutContent className="flex items-center justify-center text-center">
            <p className="text-lg">
              <FormattedMessage
                id="product.add.success"
                values={{
                  productName: productVariantState.data.attributes.product_name,
                  b: chunks => <b>{chunks}</b>,
                }}
              />
            </p>
          </LayoutContent>
          <LayoutFooter>
            <Button size="xl" className="w-full" onClick={close} disabled={finishingFlow}>
              <FormattedMessage id="modal.actions.close" />
            </Button>
          </LayoutFooter>
        </>
      )}
    </Layout>
  )
}

export default AddProductSuccessPage
